'use strict';

/*
  PennyDropService

  Handles the Penny Drop functionality for verification of access to a bank account.

  Parameters:
    presenter [APIPresenter] (required):
      Reference to the APIPresenter in order to communicate with SOA and create data models.
*/

function PennyDropService(presenter) {
  this._presenter = presenter;
  this._accountModels = {};

  this._init = function () {};

  this.initiateVerification = function (accountId, successCallback, failureCallback) {
    if (!this._accountModels[accountId]) {
      this._retrieveAccountModel(accountId);
    }

    var model = 'banking.accounts.bank_accounts[' + this._accountModels[accountId].index + ']';
    var actionPath = model + '.verify_access';
    if (this._presenter.hasAction(actionPath)) {
      this._presenter.performAction(actionPath, null, function (data, response) {
        if (response === 200) {
          if (typeof successCallback === 'function') {
            successCallback(data, response);
          }
        } else if (typeof failureCallback === 'function') {
          failureCallback(data, response);
        }
      });
    } else {
      failureCallback({ errors: [{ code: 404, key: 'no_action_error' }] }, 404);
    }
  };

  this.confirmVerification = function (accountId, node, submitCallback, successCallback, failureCallback) {
    if (!this._accountModels[accountId]) {
      this._retrieveAccountModel(accountId);
    }

    var model = 'banking.accounts.bank_accounts[' + this._accountModels[accountId].index + ']';
    var actionPath = model + '.verify_amounts';
    if (this._presenter.hasAction(actionPath)) {
      // Create confirmation node
      // Since UI is tightly coupled with results of BE response, action execution is delegated to UI component
      $(node).mogo().create('PennyDropServiceConfirmation', {
        presenter: this._presenter,
        action: actionPath,
        onSubmitCallback: submitCallback,
        successCallback: successCallback,
        failureCallback: failureCallback
      });
    } else {
      failureCallback({ errors: [{ code: 404, key: 'no_action_error' }] }, 404);
    }
  };

  this.getVerificationState = function (accountId) {
    var model = this._retrieveAccountModel(accountId);
    if (model && model.penny_drop) {
      return model.penny_drop.status;
    }
    return null;
  };

  this._onActionPennyDropAmounts = function (node, successCallback, failureCallback, data, response) {
    if (response === 200) {
      successCallback(data, response);
    } else {
      $(node).find('button').mogo().removeDisabledLoadState();
      console.log('Penny Drop Service', data, response);
    }
  };

  this._retrieveAccountModel = function (accountId) {
    var accounts = this._presenter.getModelProperty('banking.accounts.bank_accounts');

    // Check if model in cache
    if (this._accountModels[accountId]) {
      var bankAccountInd = this._accountModels[accountId].index;
      if (accounts[bankAccountInd] && accounts[bankAccountInd].id === accountId) {
        return this._accountModels[accountId].model;
      }
    }

    // Get model and cache
    var newIndex = null;
    for (var i = 0; i < accounts.length; i++) {
      if (accounts[i].id === accountId) {
        newIndex = i;
        break;
      }
    }
    this._accountModels[accountId] = {
      index: newIndex,
      model: this._presenter.getModelProperty('banking.accounts.bank_accounts[' + newIndex + ']')
    };
    return this._accountModels[accountId].model;
  };

  this._init();
}